import { Grid } from '@mui/material'
import { useIsMember } from 'hooks/user'
import React from 'react'
import { useLazyLoadQuery } from 'react-relay'
import { graphql } from 'relay-runtime'
import { BlogPostListQuery_Query } from '__generated__/BlogPostListQuery_Query.graphql'
import { useFragment } from 'react-relay/hooks'
import { BlogPostList_User$key } from '__generated__/BlogPostList_User.graphql'
import { useEdges } from 'hooks/relay'
import { BlogPostListItem } from './BlogPostListItem'
import useStyles from './styles'
import AddBlogPosts from './fields/BlogPostsField/components/AddBlogPosts'
import TabPlaceholder from './TabPlaceholder'

interface IBlogPostListProps {
  userId: string
  editable: boolean
}

export default function BlogPostList({ userId, editable }: IBlogPostListProps) {
  const { classes } = useStyles()

  const data = useLazyLoadQuery<BlogPostListQuery_Query>(graphql`
    query BlogPostListQuery_Query($userId: ID!) {
      user: node(id: $userId) {
        ...BlogPostList_User
      }
    }
   `, {
    userId,
  }, {
    fetchPolicy: 'store-and-network',
  })

  const user = useFragment<BlogPostList_User$key>(graphql`
    fragment BlogPostList_User on User {
      self
      status
      blogPosts(first: 10) {
        edges {
          node {
            id
            ...BlogPostListItem_BlogPost
          }
        }
      }
      
      ...user_useIsMember
    }
  `, data?.user)

  const isMember = useIsMember(user)
  const isProfileCreationMode = Boolean(user?.self && isMember && user.status === 'pending')
  const blogPosts = useEdges(user?.blogPosts?.edges)

  return (
    <div className={classes.container} data-cy="profile-blog-posts">
      <Grid container spacing={2}>
        {blogPosts.map(blogPost => (
          <Grid key={blogPost.id} item xs={12} md={6}>
            <BlogPostListItem blogPostFragmentRef={blogPost} editable={editable} />
          </Grid>
        ))}
      </Grid>

      {blogPosts.length === 0 && (
        <TabPlaceholder
          title="No articles posted yet"
        />
      )}

      {editable && (
        <AddBlogPosts isProfileCreationMode={isProfileCreationMode} />
      )}
    </div>
  )
}
